var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1L1 8V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V8L10 1ZM6 10V20H14V10H6Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8L0.386059 7.21065C0.142473 7.4001 0 7.69141 0 8H1ZM10 1L10.6139 0.210648C10.2528 -0.0702159 9.74717 -0.0702159 9.38606 0.210648L10 1ZM1.58579 20.4142L2.29289 19.7071L2.29289 19.7071L1.58579 20.4142ZM19 8H20C20 7.69141 19.8575 7.4001 19.6139 7.21065L19 8ZM6 20H5C5 20.5523 5.44772 21 6 21V20ZM6 10V9C5.44772 9 5 9.44772 5 10H6ZM14 20V21C14.5523 21 15 20.5523 15 20H14ZM14 10H15C15 9.44772 14.5523 9 14 9V10ZM1.61394 8.78935L10.6139 1.78935L9.38606 0.210648L0.386059 7.21065L1.61394 8.78935ZM2 19V8H0V19H2ZM2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19H0C0 19.7957 0.31607 20.5587 0.87868 21.1213L2.29289 19.7071ZM3 20C2.73478 20 2.48043 19.8946 2.29289 19.7071L0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22V20ZM17 20H3V22H17V20ZM17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20V22C17.7957 22 18.5587 21.6839 19.1213 21.1213L17.7071 19.7071ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071L19.1213 21.1213C19.6839 20.5587 20 19.7957 20 19H18ZM18 8V19H20V8H18ZM9.38606 1.78935L18.3861 8.78935L19.6139 7.21065L10.6139 0.210648L9.38606 1.78935ZM7 20V10H5V20H7ZM14 19H6V21H14V19ZM13 10V20H15V10H13ZM6 11H14V9H6V11Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.58c1bcea5e733868bd27080eb99c89fd.svg";
export { ForwardRef as ReactComponent };